// 封装axios的请求，返回重新封装的数据格式
// 对错误的统一处理
import axios from 'axios'
import store from '@/store'
import qs from 'qs'
import router from '@/router'
// const CancelToken = axios.CancelToken
import Message from '@/utils/message'
import { removeToken } from '@/utils/auth'
import { uuid } from './index'
import { addRequest, removeRequest } from './loading'

class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
    this.pending = {}
    this.customData = {
      isCatchCallback: false, // 报错提示是否使用公共报错
      isEncrypt: false // 是否使用加密
    }
    this.uuid = uuid()
  }

  // 获取axios配置
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      withCredentials: true, // 跨域
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      customData: this.customData,
      timeout: 60000
    }
    return config
  }

  removePending(key, isRequest = false) {
    if (this.pending[key] && isRequest) {
      this.pending[key]('取消重复请求')
    }
    delete this.pending[key]
  }

  /**
   * @description 出错回调
   * @param {*} err
   * @returns
   * @memberof HttpRequest
   */
  errorCallback(err) {
    const { config } = err
    const _data = err.data || err.response.data

    const errRes = {
      message: (_data && _data.message) || err.message || '网络出小差了！',
      code: (_data && _data.code) || err.code
    }
    if (_data.code === 'Unauthorized' || err.response.status === 401) {
      removeToken()
      // const redirect = encodeURIComponent(window.location.pathname)
      router.replace({
        path: '/login'
      })
    }
    // debugger
    // 如果自定义错误回调，则跳过统一提示
    if (!config?.customData?.isCatchCallback) {
      Message.error(errRes.message)
    }
    // Do something with request error
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(errRes)
  }

  // 设定拦截器
  interceptors(instance) {
    // 请求拦截器
    instance.interceptors.request.use(
      (config) => {
        addRequest(this)

        const token = store.getters.token
        if (token) {
          config.headers['Auth-Token'] = token
        }
        config.customData = this.customData
        if (config.customData && config.customData.headers) {
          const customHeader = config.customData.headers
          for (const h in customHeader) {
            config.headers[h] = customHeader[h]
          }
        }
        return config
      },
      (err) => {
        removeRequest(this)
        // debugger
        return this.errorCallback(err)
      }
    )

    // 响应请求的拦截器
    instance.interceptors.response.use(
      (res) => {
        removeRequest(this)

        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        const key = res.config.url + '&' + res.config.method
        this.removePending(key)
        if (res && res.data && res.data.res_code === 1) {
          return Promise.resolve(res.data)
        } else if (res.headers['content-type'].indexOf('application/octet-stream') !== -1) {
          const fileName = decodeURI(res.headers['content-disposition'].split('=')[1])
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(new Blob([res.data])) // 创建下载的连接
          downloadElement.href = href
          downloadElement.download = fileName// 处理文件名乱问题， 下载后文件
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          return Promise.resolve(res)
        } else {
          // 导出数据处理
          if (res.config.responseType) {
            return Promise.resolve(res.data)
          } else {
            return this.errorCallback(res)
          }
        }
      },
      (err) => {
        removeRequest(this)

        return this.errorCallback(err)
      }
    )
  }

  /**
   * @description 创建实例
   * @param {*} options
   * @returns
   * @memberof HttpRequest
   */
  request(options) {
    const instance = axios.create()
    const newOptions = Object.assign(this.getInsideConfig(), options)
    this.customData = {
      isCatchCallback: false,
      ...newOptions.customData
    }
    this.interceptors(instance)
    return instance(newOptions)
  }

  /**
   * @description get
   * @param {string} url 请求地址
   * @param {object} params 请求参数
   * @param {object} [customData={}] 自定义参数
   * @param {boolean} [customData={isCatchCallback = false}] 是否自定义错误提示？默认false统一提示报错
   * @returns
   * @memberof HttpRequest
   */
  get(url, params, customData = {}, othersOptions = {}) {
    return this.request({
      method: 'get',
      url: url,
      params: qs.parse(qs.stringify(params)),
      customData: {
        ...customData
      },
      ...othersOptions
    })
  }

  /**
   * @description post
   * @param {string} url 请求地址
   * @param {object} data 请求参数
   * @param {object} headers 请求头
   * @param {object} [customData={}] 自定义参数
   * @param {boolean} [customData={isCatchCallback = false}] 是否自定义错误提示？默认false统一提示报错
   * @returns
   * @memberof HttpRequest
   */
  post(url, data, headers = {}, customData = {}, othersOptions = {}) {
    return this.request({
      method: 'post',
      url: url,
      data: data,
      headers: headers,
      timeout: 60000,
      customData: {
        ...customData
      },
      ...othersOptions
    })
  }

  upload(url, data, headers, customData = {}) {
    var formData = new FormData()
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key])
    })
    return this.request({
      method: 'post',
      url: url,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        ...headers
      },
      customData: {
        ...customData
      }
    })
  }
}

export default HttpRequest
